// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filter-container[data-v-432db3a0] {\n  padding-bottom: 10px;\n}\n\n/* 给 el-form 加个类，用于穿透修改样式 */\n.compact-form[data-v-432db3a0] .el-form-item {\n  margin-bottom: 8px !important; /* 上下间距 10px */\n}\n", ""]);
// Exports
module.exports = exports;
